<div class="assignees__wrapper" data-test="assigneesSection">
  <label class="pointCF__label" [class.pointAssignees__bulk]="ppBulkChanges">
    <div class="pointCF__label-image--container">
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_ACTIVITIES_USER_18]"
        ppColor="inherit"
        ppClass="setSize18"
      />
    </div>

    <span
      ppTooltip
      class="pointCF__label-container"
      [ppTitle]="'assignees' | ppTranslate"
      [ppTrimTooltip]="true"
    >
      {{ 'assignees' | ppTranslate }}
    </span>
  </label>

  <div class="assignees__content">
    @for (userId of selectedAssignees; track userId) {
      <div
        class="assigneesSearch__assignees"
        id="userButton{{ userId }}"
        (click)="
          toggleUserDropdown('userButton' + userId, userId); $event.stopImmediatePropagation()
        "
      >
        @if (allUsers[userId]?.avatarPublicUrl) {
          <img
            ppTooltip
            ppImage
            class="assignees__avatar"
            [src]="allUsers[userId]?.avatarPublicUrl"
            [ppTitle]="allUsers[userId]?.userName"
          />
        }
        @if (!allUsers[userId]?.avatarPublicUrl && allUsers[userId]) {
          <img
            ppTooltip
            class="assignees__avatar"
            [src]="EIconPath.PLACEHOLDER_USER"
            [ppTitle]="allUsers[userId]?.userName"
          />
        }
      </div>
    }

    @if (!ppDisabled) {
      <pp-icon
        [id]="ppBulkChanges ? 'addAssigneesButtonBulk' : 'addAssigneesButton'"
        class="assignees__select-button"
        [ppSVG]="iconMap[EIconPath.ICON_INPUT_PLUS_32]"
        [ppColor]="addAssigneesDropdownVisible ? 'primary-600' : 'grey-400'"
        [ppHoverColor]="addAssigneesDropdownVisible ? 'primary-600' : 'grey-600'"
        (click)="showAssigneesDropdown()"
        data-test="addAssignee"
      />
    }
  </div>
</div>
